const API_URL = import.meta.env.VITE_API_URL || 'https://api.flydev.silliestduck.com';

export interface AuthState {
  isAuthenticated: boolean;
  sessionId: string | null;
  username: string | null;
}

// Check if user has a session
export function hasSession(): boolean {
  return localStorage.getItem('sessionId') !== null;
}

export function getStoredUsername(): string | null {
  return localStorage.getItem('username');
}

export function getStoredSessionId(): string | null {
  return localStorage.getItem('sessionId');
}

// Login with Google OAuth
export function loginWithGoogle(inviteCode?: string): void {
  // Pass invite code as query parameter to OAuth start endpoint
  const url = inviteCode
    ? `${API_URL}/auth/google?invite=${encodeURIComponent(inviteCode)}`
    : `${API_URL}/auth/google`;
  window.location.href = url;
}

// Handle OAuth callback (extract sessionId from URL)
export function handleOAuthCallback(): { sessionId?: string; error?: string } {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get('sessionId');
  const error = params.get('error');

  if (sessionId) {
    localStorage.setItem('sessionId', sessionId);
    return { sessionId };
  }

  if (error) {
    return { error };
  }

  return {};
}

// Get user info from backend
export async function getUserInfo(sessionId: string): Promise<{ username?: string; error?: string }> {
  try {
    const response = await fetch(`${API_URL}/me`, {
      headers: {
        'X-Session-ID': sessionId
      }
    });

    if (!response.ok) {
      return { error: 'Failed to fetch user info' };
    }

    const data = await response.json();
    const username = data.user.username;

    // Store username for display
    localStorage.setItem('username', username);

    return { username };
  } catch (error: any) {
    return { error: error.message || 'Failed to fetch user info' };
  }
}

// Clear session data
export function clearSession() {
  localStorage.removeItem('sessionId');
  localStorage.removeItem('username');
}
